import { memo } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogActions,
  DialogProps,
  DialogContent,
  Breakpoint,
  Button,
} from '@mui/material';

import { Dialog as DialogType } from '../../hooks/useDialog';
import { Typography } from '../Typography/Typography';

interface ConfirmDialogProps extends DialogProps {
  width?: string;
  maxWidth?: Breakpoint;
  dialog: DialogType;
  open: boolean;
  onClose: () => void;
}

const ConfirmDialog = ({
  width,
  maxWidth,
  dialog,
  open,
  onClose,
  ...props
}: ConfirmDialogProps) => (
  <Dialog
    open={open}
    onClose={onClose}
    maxWidth="lg"
    sx={{ '& .MuiDialog-paper': { width: width } }}
    {...props}
  >
    {dialog.header && (
      <DialogTitle>
        {typeof dialog.header === 'string' ? (
          <>
            <Typography fontSize="1.25rem" fontWeight="500" lineHeight="32px">
              {dialog.header}
            </Typography>
            {typeof dialog.target === 'string' ? (
              <Typography fontSize="0.75rem" lineHeight="20px" color="#00000099">
                {dialog.target}
              </Typography>
            ) : (
              dialog.target
            )}
          </>
        ) : (
          dialog.header
        )}
      </DialogTitle>
    )}
    {dialog.main && (
      <DialogContent>
        {typeof dialog.main === 'string' ? (
          <Typography fontSize="0.875rem" lineHeight="20px">
            {dialog.main}
          </Typography>
        ) : (
          dialog.main
        )}
      </DialogContent>
    )}
    <DialogActions>
      <Button variant="text" color="info" onClick={onClose} sx={{ textTransform: 'none' }}>
        {dialog.cancelText ? dialog.cancelText : 'Отменить'}
      </Button>
      {typeof dialog.footer === 'function' ? (
        <Button
          variant="contained"
          onClick={dialog.footer}
          color="info"
          sx={{ textTransform: 'none' }}
        >
          {dialog.submitText ? dialog.submitText : 'Подтвердить'}
        </Button>
      ) : (
        dialog.footer
      )}
    </DialogActions>
  </Dialog>
);

export const ConfirmDialogMemo = memo(ConfirmDialog);
